import _ from "underts";
import rdvsFromPlage from "./rdvsFromPlage.js";
import getEmptyCases from "./emptyCases.js";
import relevantHoraire from "../horaires/relevantHoraire.js";
import bornesForDay from "../horaires/bornesForDay.js";
const heuresPossibles = (allHoraires, allRdvs, dateProposed, _hmProposed, dureeMiniRdv, currentRdv) => {
    "use strict";
    const horaire = relevantHoraire(allHoraires, dateProposed);
    if (!horaire) {
        return [];
    }
    const bornes = bornesForDay(horaire, dateProposed);
    //const plage = getPlageFromHM(hmProposed, bornes);
    const dayRdvs = allRdvs.filter((r) => r.date.getTime() === dateProposed.getTime());
    const foo = bornes.map((plage) => rdvsFromPlage(dayRdvs, plage));
    const bar = foo.map((plageRdvs, index) => getEmptyCases(plageRdvs, bornes[index], dureeMiniRdv, currentRdv));
    return bar.flat();
    // return getEmptyCases(plageRdvs, plage, dureeMiniRdv, currentRdv);
};
const heuresPossibles3 = (horaire, allRdvs, dateProposed, dureeMiniRdv, oldRdv) => {
    const bornes = bornesForDay(horaire, dateProposed);
    const dayRdvs = allRdvs.filter((rdv) => rdv.date.getTime() === dateProposed.getTime());
    const foo = bornes.map((plage) => rdvsFromPlage(dayRdvs, plage));
    const bar = foo.map((plageRdvs, index) => getEmptyCases(plageRdvs, bornes[index], dureeMiniRdv, oldRdv));
    return bar.flat(1);
};
function groupByContiguousEmptyCases(emptyCases) {
    const sorted = _.sortBy(emptyCases, (emptyCase) => emptyCase.hour * 60 + emptyCase.minute);
    let result = [];
    let currentGroup = [];
    for (const kase of sorted) {
        if (currentGroup.length === 0) {
            currentGroup.push(kase);
        }
        else {
            const last = _.last(currentGroup);
            if (!last) {
                throw new Error("last is undefined in groupByContiguousEmptyCases");
            }
            if (last.hour * 60 + last.minute + last.duration ===
                kase.hour * 60 + kase.minute) {
                currentGroup.push(kase);
            }
            else {
                result.push([...currentGroup]);
                currentGroup = [kase];
            }
        }
    }
    if (currentGroup.length > 0) {
        result.push([...currentGroup]);
    }
    return result;
}
function filterEmptyCasesSatisfyingDuration(emptyCases, targetDuration) {
    const casesGroupedByContiguous = groupByContiguousEmptyCases(emptyCases);
    return casesGroupedByContiguous
        .map((group) => {
        return group.filter((kase, idx) => {
            const availableCaseDuration = (group.length - idx) * kase.duration;
            return availableCaseDuration >= targetDuration;
        });
    })
        .flat();
}
const hmAvailableWithDuration = (horaire, allAppointments, dateProposed, dureeMiniRdv, targetDuration, oldAppointment) => {
    const bornes = bornesForDay(horaire, dateProposed);
    const dayRdvs = allAppointments.filter((rdv) => rdv.date.getTime() === dateProposed.getTime());
    const existingAptGroupedByPlage = bornes.map((plage) => rdvsFromPlage(dayRdvs, plage));
    const emptyCasesGroupedByPlage = existingAptGroupedByPlage.map((plageRdvs, index) => getEmptyCases(plageRdvs, bornes[index], dureeMiniRdv, oldAppointment));
    const flattenedEmptyCases = emptyCasesGroupedByPlage.flat(1);
    return filterEmptyCasesSatisfyingDuration(flattenedEmptyCases.map((kase) => ({ ...kase, duration: dureeMiniRdv })), targetDuration);
};
export default heuresPossibles;
export { heuresPossibles3, hmAvailableWithDuration };
//# sourceMappingURL=heuresPossibles.js.map